import { HttpClient } from "@angular/common/http";
import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
	selector: "jt-landing-page",
	templateUrl: "./landing-page.component.html",
	styleUrls: ["./landing-page.component.scss"],
})
export class LandingPageComponent implements OnInit {
	constructor() { }

	ngOnInit(): void {
	}
}
